// TODO refactor this (unify both enums)
export enum QrStateEnum {
  valid = 'VALID',
  error = 'ERROR',
  blackList = 'BLACK_LIST',
  inactive = 'INACTIVE',
  maxScans = 'MAX_SCANS',
  outOfDate = 'OUT_OF_DATE',
}

export enum ScanStatusEnum {
  SAME_DEVICE = 'sameDevice',
  SAME_DEVICE_MULTI_QR = 'sameDeviceMultiQr',
  OTHER_DEVICE = 'otherDevice',
  BLACK_LIST = 'blackList',
  ERROR = 'error',
  MAX_DI_SCANS_ACHIEVED = 'maxDiScansAchieved',
  OUT_OF_DATE = 'outOfDate',
  MULTISCAN_LIMIT = 'multiScanLimit',
  CONSUMABLE_SCAN_LIMIT = 'consumableScanLimit',
}

// TODO: Check this in loginForm
export enum ScanErrorEnum {
  ASSIGN_POINTS_LIMIT_OVERPASS = '0073',
  QR_REPEATED_SCAN = '0077',
  QR_MULTI_CLIENT_OUT_OF_DATE = '0078',
}

export enum ScanErrorCodesEnum {
  MULTISCAN_LIMIT_ERROR = 'consumable-variant-multi-scan-limit-error',
  QR_MULTI_CLIENT_OUT_OF_DATE = 'qr-multi-client-out-of-date',
  CUSTOMER_BLACKLISTED = 'customer-blacklisted-error',
  QR_ALREADY_CONSUMED = 'qr-already-consumed-error',
  QR_ALREADY_CONSUMED_BY_OTHER = 'qr-already-consumed-by-other-user-error',
  CUSTOMER_SCAN_LIMIT_EXCEEDED = 'consumable-variant-scan-limit-error',
}